import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { HeroV2 } from "@/components/site/v2/HeroV2";
import { AnimatedStats } from "@/components/site/v2/AnimatedStats";
import { IntentsV2 } from "@/components/site/v2/IntentsV2";
import { AboutV2 } from "@/components/site/v2/AboutV2";
import { EventsV2 } from "@/components/site/v2/EventsV2";
import { ProgramsV2 } from "@/components/site/v2/ProgramsV2";
import { GalleryV2 } from "@/components/site/v2/GalleryV2";
import { NewsV2 } from "@/components/site/v2/NewsV2";
import { FinalCTAV2 } from "@/components/site/v2/FinalCTAV2";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function HomeV2() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay />
      <main id="content" tabIndex={-1} className="outline-none">
        <HeroV2 />
        <AnimatedStats />
        <IntentsV2 />
        <AboutV2 />
        <EventsV2 />
        <ProgramsV2 />
        <GalleryV2 />
        <NewsV2 />
        <FinalCTAV2 />
      </main>
      <SiteFooter />
    </>
  );
}
